import { useState } from "react";
import { Col, Row, Drawer, Image } from "antd";
// import myProfileicon from "../../assets/myprofile.png";
// import jumplogicon from "../../assets/jumplog.png";
// import gifticon from "../../assets/gift.png";
// import clockicon from "../../assets/clock.png";
import { useNavigate } from "react-router";
import { useLocation } from "react-router-dom";
import { LiaFileContractSolid } from "react-icons/lia";
import { ImageUrl } from "../../config/helper";

import { MdMenu } from "react-icons/md";
import { FaIdCardAlt, FaRegUserCircle } from "react-icons/fa";
import { FaUsers, FaUserShield } from "react-icons/fa6";
const SideMenu = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  const location = useLocation();
  return (
    <>
      <Row>
        <Col xs={0} md={0} lg={0} xl={24}>
          <div className="side-menu">
            <div
              className={`vector-one-parent ${
                location.pathname === "/profile" ||
                location.pathname === "/Profile" ||
                location.pathname === "/editProfile"
                  ? "active"
                  : ""
              }`}
            >
              <FaRegUserCircle className="vector-one-icon" />
              <div
                className="my-profile"
                style={{ cursor: "pointer" }}
                onClick={() => navigate("/profile")}
              >
                Account
              </div>
            </div>
            <div
              className={`gift-cards-text-parent ${
                location.pathname.includes("/chauffeurBookingLogs") &&
                !location.pathname.includes("/complete/")
                  ? "active"
                  : ""
              }`}
            >
              <FaIdCardAlt className="vector-one-icon" />
              <div
                className="jump-reservation-logs"
                style={{ cursor: "pointer" }}
                onClick={() => navigate("/chauffeurBookingLogs")}
              >
                Recent Trips
              </div>
            </div>
            <div
              className={`gift-cards-text-parent ${
                location.pathname.includes("/membershipPlanLog") ? "active" : ""
              }`}
            >
              <FaUsers className="vector-one-icon" />
              <div
                className="jump-reservation-logs"
                style={{ cursor: "pointer" }}
                onClick={() => navigate("/membershipPlanLog")}
              >
                Memberships
              </div>
            </div>
            <div
              className={`location-text-parent ${
                location.pathname.includes("/chauffeurBookingmember") ||
                location.pathname.includes("/chauffeurBookingLogs/complete/")
                  ? "active"
                  : ""
              }`}
            >
              <FaUserShield className="vector-one-icon" />
              <div
                className="gift-cards"
                style={{ cursor: "pointer" }}
                onClick={() => navigate("/chauffeurBookingmember")}
              >
                {/* Bookings  Against<br />Membership */}
                History Bookings
              </div>
            </div>
            <div
              className={`vector-one-parent ${
                location.pathname === "/profile" ||
                location.pathname === "/Profile" ||
                location.pathname === "/editProfile"
                  ? "active"
                  : ""
              }`}
            >
              <FaRegUserCircle className="vector-one-icon" />
              <div
                className="my-profile"
                style={{ cursor: "pointer" }}
                onClick={() =>
                  navigate("/profile", { state: { showButtons: true } })
                }
              >
                Settings
              </div>
            </div>
          </div>
        </Col>
        <Col xs={24} md={24} lg={24} xl={0}>
          <>
            <MdMenu
              style={{ fontSize: 26, color: "#000" }}
              onClick={showDrawer}
            />
            <Drawer placement="right" onClose={onClose} open={open}>
              <div className="side-menu">
                <div className="bg2" />
                <div className="vector-one-parent">
                  <FaRegUserCircle className="vector-one-icon" />
                  <div
                    className="my-profile"
                    style={{ cursor: "pointer" }}
                    onClick={() => navigate("/profile")}
                  >
                    Account
                  </div>
                </div>
                <div className="reservation-logs-text">
                  <div
                    className={`gift-cards-text-parent ${
                      location.pathname.includes("/chauffeurBookingLogs") &&
                      !location.pathname.includes("/complete/")
                        ? "active"
                        : ""
                    }`}
                  >
                    <FaIdCardAlt className="vector-one-icon" />
                    <div
                      className="jump-reservation-logs"
                      style={{ cursor: "pointer" }}
                      onClick={() => navigate("/chauffeurBookingLogs")}
                    >
                      Recent Trips
                    </div>
                  </div>
                  <div
                    className={`gift-cards-text-parent ${
                      location.pathname.includes("/membershipPlanLog")
                        ? "active"
                        : ""
                    }`}
                  >
                    <FaUsers className="vector-one-icon" />
                    <div
                      className="jump-reservation-logs"
                      style={{ cursor: "pointer" }}
                      onClick={() => navigate("/membershipPlanLog")}
                    >
                      Memberships
                    </div>
                  </div>
                  <div
                    className={`location-text-parent ${
                      location.pathname.includes("/chauffeurBookingmember") ||
                      location.pathname.includes(
                        "/chauffeurBookingLogs/complete/"
                      )
                        ? "active"
                        : ""
                    }`}
                  >
                    <FaUserShield className="vector-one-icon" />
                    <div
                      className="gift-cards"
                      style={{ cursor: "pointer" }}
                      onClick={() => navigate("/chauffeurBookingmember")}
                    >
                      {/* Bookings Against<br /> Membership */}
                      History Bookings
                    </div>
                  </div>
                  <div className="vector-one-parent">
                    <FaRegUserCircle className="vector-one-icon" />
                    <div
                      className="my-profile"
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        navigate("/profile", { state: { showButtons: true } })
                      }
                    >
                      Settings
                    </div>
                  </div>
                </div>
              </div>
            </Drawer>
          </>
        </Col>
      </Row>
    </>
  );
};

export default SideMenu;
